import _defineProperty from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * DevExtreme (esm/renovation/ui/common/icon.js)
 * Version: 22.1.5
 * Build date: Fri Sep 02 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/esm/extends";
var _excluded = ["iconTemplate", "position", "source"];
import { createVNode, createFragment, createComponentVNode, normalizeProps } from "inferno";
import { Fragment } from "inferno";
import { BaseInfernoComponent } from "@devextreme/runtime/inferno";
import { getImageSourceType } from "../../../core/utils/icon";
import { combineClasses } from "../../utils/combine_classes";
export var viewFunction = function viewFunction(_ref) {
  var iconClassName = _ref.iconClassName,
      _ref$props = _ref.props,
      IconTemplate = _ref$props.iconTemplate,
      source = _ref$props.source,
      sourceType = _ref.sourceType;
  return createFragment(["dxIcon" === sourceType && createVNode(1, "i", iconClassName), "fontIcon" === sourceType && createVNode(1, "i", iconClassName), "image" === sourceType && createVNode(1, "img", iconClassName, null, 1, {
    alt: "",
    src: source
  }), IconTemplate && createVNode(1, "i", iconClassName, IconTemplate({}), 0)], 0);
};
export var IconProps = {
  position: "left",
  source: ""
};

var getTemplate = function getTemplate(TemplateProp) {
  return TemplateProp && (TemplateProp.defaultProps ? function (props) {
    return normalizeProps(createComponentVNode(2, TemplateProp, _extends({}, props)));
  } : TemplateProp);
};

export var Icon =
/*#__PURE__*/
function (_BaseInfernoComponent) {
  _inherits(Icon, _BaseInfernoComponent);

  function Icon(props) {
    var _this;

    _classCallCheck(this, Icon);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Icon).call(this, props));
    _this.state = {};
    return _this;
  }

  _createClass(Icon, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return viewFunction({
        props: _extends({}, props, {
          iconTemplate: getTemplate(props.iconTemplate)
        }),
        sourceType: this.sourceType,
        cssClass: this.cssClass,
        iconClassName: this.iconClassName,
        restAttributes: this.restAttributes
      });
    }
  }, {
    key: "sourceType",
    get: function get() {
      return getImageSourceType(this.props.source);
    }
  }, {
    key: "cssClass",
    get: function get() {
      return "left" !== this.props.position ? "dx-icon-right" : "";
    }
  }, {
    key: "iconClassName",
    get: function get() {
      var generalClasses = _defineProperty({
        "dx-icon": true
      }, this.cssClass, !!this.cssClass);

      var source = this.props.source;

      if ("dxIcon" === this.sourceType) {
        return combineClasses(_extends({}, generalClasses, _defineProperty({}, "dx-icon-".concat(source), true)));
      }

      if ("fontIcon" === this.sourceType) {
        return combineClasses(_extends({}, generalClasses, _defineProperty({}, String(source), !!source)));
      }

      if ("image" === this.sourceType) {
        return combineClasses(generalClasses);
      }

      if ("svg" === this.sourceType) {
        return combineClasses(_extends({}, generalClasses, {
          "dx-svg-icon": true
        }));
      }

      return "";
    }
  }, {
    key: "restAttributes",
    get: function get() {
      var _this$props = this.props,
          restProps = _objectWithoutPropertiesLoose(_this$props, _excluded);

      return restProps;
    }
  }]);

  return Icon;
}(BaseInfernoComponent);
Icon.defaultProps = IconProps;